import React from "react";

import HomeSlider from "../Components/Inicio/HomeSlider";
import Promociones from "../Components/Inicio/Promociones";

const Inicio = () => {
  return (
    <div className="">
      <HomeSlider />
      <Promociones />
    </div>
  );
};

export default Inicio;
